import axios, { AxiosInstance, AxiosResponse } from 'axios'
import qs from 'qs'

export interface ApiService{
    get<Req, Res>(url: string, data?: Req): Promise<AxiosResponse>;
    post<Req, Res>(url: string, data: Req): Promise<AxiosResponse>;
    put<Req, Res>(url: string, data: Req): Promise<AxiosResponse>;
    patch<Req, Res>(url: string, data: Req): Promise<AxiosResponse>;
    delete<Req, Res>(url: string, data?: Req): Promise<AxiosResponse>;
}

const client = axios.create({
    withCredentials: true,
    responseType: 'json',
    headers: {
        'Content-Type': 'application/json; charset=utf8'
    },
    transformResponse: (data) => {
        return JSON.parse(JSON.stringify(data))
    }
})

export default class Service implements ApiService {
    private client: AxiosInstance;

    constructor () {
        this.client = client
    }

    public async get<Request, Response> (url: string, data?: Request): Promise<AxiosResponse> {
        return await this.client.get<Response>(url, {
            params: data,
            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
        })
    }

    public async patch<Request, Response> (url: string, data: Request): Promise<AxiosResponse> {
        return await this.client.patch<Response>(url, data)
    }

    public async post<Request, Response> (url: string, data: Request): Promise<AxiosResponse> {
        return await this.client.post<Response>(url, data)
    }

    public async put<Request, Response> (url: string, data: Request): Promise<AxiosResponse> {
        return await this.client.put<Response>(url, data)
    }

    public async delete<Request, Response>(url: string, data?: Request): Promise<AxiosResponse> {
        return await this.client.delete<Response>(url, data)
    }
}
